import axios from 'axios';
// const CancelToken = axios.CancelToken;



export default {
    //get请求
    get2(url, param) {
        return axios()
    },

    //get请求
    get(url, param) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: url.indexOf('?') == -1 ? url + '?_=' + (new Date()).getTime() : url + '&_=' + (new Date()).getTime(),
                params: param

            }).then(res => {
                resolve(res.data)
            })
        })
    },
    //post请求
    post(url, param) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: url,
                data: param
            }).then(res => {
                resolve(res.data)
            })
        })
    },

    postForm(url, param) {
        return new Promise((resolve, reject) => {
            axios({
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                method: 'post',
                url,
                data: param

            }).then(res => {
                resolve(res)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/service/fetch.js